<template>
  <v-app>
    <v-container class="d-flex align-items-center min-vh-100">

      <v-row class="w-100 justify-content-center">
        <v-col md="6">
          <div class="w-100">
            <div class="clearfix">
              <h1 style="font-size: 95px">403</h1>
              <h2 class="pt-3"> خطای دسترسی </h2>
              <p class="text-muted">شما به این صفحه دسترسی ندارید</p>
            </div>
            <v-row class="w-100 justify-content-center">
              <v-col md="6">
                <v-btn
                    @click="$router.go(-1)"
                    block
                    class="primary"
                >
                  برگشت
                </v-btn>
              </v-col>
              <v-col md="6">
                <v-btn
                    to="/home"
                    block
                    class="info "
                >

                  داشبورد
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

</template>

<script>
export default {
  name: 'Page403'
}
</script>
<style>

</style>
